import { Mail, Phone } from 'lucide-react';

import { Badge } from '@apps/web/components/ui/badge';
import { cn } from '@apps/web/lib/utils';
import { type ContactType } from '@libraries/typescript/api_client';
import { assert } from '@libraries/typescript/utilities';

type ContactBadgeProps = {
    readonly type: ContactType;
    readonly address: string;
    readonly variant?: 'default' | 'secondary' | 'destructive' | 'outline';
    readonly className?: string;
};

export function ContactBadge({
    type,
    address,
    variant = 'outline',
    className = '',
}: ContactBadgeProps) {
    return (
        <Badge
            variant={variant}
            className={cn('flex items-center gap-1 text-xs', className)}
        >
            {(() => {
                switch (type) {
                    case 'phone':
                        return <Phone className="h-3 w-3" />;
                    case 'email':
                        return <Mail className="h-3 w-3" />;
                    default:
                        assert.never(type);
                }
            })()}
            {address}
        </Badge>
    );
}
